import axios from 'axios';

const BASE_URL = 'https://redspeedapi.redstarplc.com/api'

export default axios.create({
    baseURL: BASE_URL,
});